<template>
    <div>
        <loader :loader="isLoading" v-if="isLoading" />
        <div v-if="!isLoadingUser">
            <div v-if="!isLoading" class="d-flex justify-content-between mb-2">
                <h5 class="text-muted">
                    {{ $t('values.valuersOfSubordinates', { name: user.name }) }}
                </h5>
                <b-button id="btn-values-collapse-all" size="sm" variant="outline-primary" @click="setToggleCollapse()">
                    <div class="d-flex flex-row align-items-center">
                        <span>{{ collapseButtonText }}</span>
                    </div>
                </b-button>
            </div>
            <div v-for="subordinate in subordinates" :key="subordinate.id">
                <subordinate-networks
                    :subordinate="subordinate"
                    :toggleAll="toggleAll"
                    @loaded="isLoadingNetworks = false"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Loader from '@/views/components/loader'
import subordinateNetworks from './components/subordinateNetworks'
import { getUser } from '@/views/values/api'
import i18n from '@/i18n'

export default {
    components: {
        Loader,
        subordinateNetworks,
    },
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isLoadingUser: true,
            isLoadingNetworks: true,
            toggleAll: true,
            subordinates: [],
        }
    },
    mounted() {
        let ViewModeValue = this.getViewModeValue()
        if (ViewModeValue != null) {
            this.toggleAll = ViewModeValue
        }
        this.getSubordinates()
    },
    methods: {
        getSubordinates() {
            this.user.subordinates.forEach((subordinate) => {
                getUser(subordinate.id)
                    .then((user) => {
                        this.subordinates.push(user)
                    })
                    .finally(() => {
                        this.isLoadingUser = false
                    })
            })
        },
        getViewModeValue() {
            return JSON.parse(localStorage.getItem('SUBORDINATE_NETWORKS_VIEW_MODE'))
        },
        setToggleCollapse() {
            this.toggleAll = !this.toggleAll
            localStorage.setItem('SUBORDINATE_NETWORKS_VIEW_MODE', this.toggleAll)
        },
    },
    computed: {
        isLoading() {
            return this.isLoadingUser || this.isLoadingNetworks
        },
        collapseButtonText() {
            return this.toggleAll ? i18n.t('form.button.collapseAll') : i18n.t('form.button.expandAll')
        },
    },
}
</script>
